import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { Dictionary, DictionaryType } from '../../../../domain/dictionary.model';
import { ValidationError } from '../../../../domain/error.model';
import { Party, PartyType } from '../../../../domain/party.domain';
import { ErrorAwareComponent, LsnErrorStateMatcher } from '../../../shared/middleware/error-state-matcher';
import { DictionaryState } from '../../store/dictionary.state';
import { ErrorsState } from '../../store/errors.state';

@Component({
    selector: 'app-party-form',
    templateUrl: './party-form.component.html',
    styleUrls: ['./party-form.component.scss']
})
export class PartyFormComponent implements OnInit, OnDestroy, ErrorAwareComponent {

    @Output() removeClicked = new EventEmitter<Party>();
    @Input() companyAllowed = false;
    @Input() aside = false;
    @Input() noPeselLabel = 'LABEL.NO_PESEL';
    @Input() blockPeselForForeigner = true;
    @Input() title: string;
    @Input() hasRemoveInsured = false;
    @Input() party: Party;
    @Input() prefix: string;
    @Input() allowForeignAddress = false;

    @Select(DictionaryState.getDictionaries) dictionaries$: Observable<{ [key: string]: Dictionary }>;
    dictionaryTypes = DictionaryType;

    @Select(ErrorsState.getMainErrors) mainErrors$: Observable<ValidationError[]>;
    @Select(ErrorsState.getAsideErrors) asideErrors$: Observable<ValidationError[]>;
    errors: ValidationError[] = [];
    subscriptions: Subscription[] = [];

    matchers: any = {};
    partyTypes = PartyType;


    set foreigner(value) {
        this.party.foreigner = value;
        if (value === true && this.blockPeselForForeigner) {
            this.party.pesel = null;
            this.party.citizenship = {code: null};
        }
    }


    constructor() {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.aside
                ? this.asideErrors$.subscribe(errors => this.errors = errors)
                : this.mainErrors$.subscribe(errors => this.errors = errors)
        );
        this.prepareMatchers();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }


    private prepareMatchers() {
        const merge = (field: string) => this.prefix
            ? `${this.prefix}.${field}`
            : field;

        this.matchers = {
            typeCode: new LsnErrorStateMatcher(this, `${merge('typeCode')}`),
            firstName: new LsnErrorStateMatcher(this, `${merge('firstName')}`),
            lastName: new LsnErrorStateMatcher(this, `${merge('lastName')}`),
            companyName: new LsnErrorStateMatcher(this, `${merge('companyName')}`),
            companyNumber: new LsnErrorStateMatcher(this, `${merge('companyNumber')}`),
            companyCountry: new LsnErrorStateMatcher(this, `${merge('companyCountry')}`),
            maidenName: new LsnErrorStateMatcher(this, `${merge('maidenName')}`),
            pesel: new LsnErrorStateMatcher(this, `${merge('pesel')}`),
            frontier: new LsnErrorStateMatcher(this, `${merge('frontier')}`),
            foreigner: new LsnErrorStateMatcher(this, `${merge('foreigner')}`),
            citizenship: new LsnErrorStateMatcher(this, `${merge('citizenship')}`),
            birthDate: new LsnErrorStateMatcher(this, `${merge('birthDate')}`),
            gender: new LsnErrorStateMatcher(this, `${merge('gender')}`),
            documentType: new LsnErrorStateMatcher(this, `${merge('documentType')}`),
            documentNumber: new LsnErrorStateMatcher(this, `${merge('documentNumber')}`),
            mainAddress: new LsnErrorStateMatcher(this, `${merge('mainAddress')}`),
            otherCorrespondenceAddress: new LsnErrorStateMatcher(this, `${merge('otherCorrespondenceAddress')}`),
            correspondenceAddress: new LsnErrorStateMatcher(this, `${merge('correspondenceAddress')}`),
            drivingLicenseDate: new LsnErrorStateMatcher(this, `${merge('drivingLicenseDate')}`),
        };
    }

    remove() {
        this.removeClicked.emit(this.party);
    }
}
